// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

export const profileSlice = createSlice({
  name: "user_data",
  initialState: {
    profile: null,
    web_fcm_token:null
  },
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    updateToken: (state, action) => {
      state.web_fcm_token = action.payload;
  },
  },
});

export const { setProfile ,updateToken} = profileSlice.actions;

export default profileSlice.reducer;
